import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { cn } from '@/utils'
import { ReactNode } from 'react'
type TablePlaceholderProps = {
  className?: string
  rows: Array<{
    [key: string]: string | ReactNode
  }>
  columns: {
    [key: string]: {
      title: string
      width: number
    }
  }
}
export const TablePlaceholder = ({
  className,
  rows,
  columns,
}: TablePlaceholderProps) => {
  return (
    <div
      className="border box-content p-px rounded-md"
      style={{ borderColor: '#818cf8' }}
    >
      <Table
        className={cn(
          'border-y border-solid border-gray-200 border-collapse',
          className,
        )}
      >
        <TableHeader className="bg-muted/80">
          <TableRow className="w-full">
            {Object.keys(columns).map((column) => (
              <TableHead
                key={column}
                className="relative items-center border-x border-solid border-gray-200 border-collapse text-xs h-auto py-1"
                style={{ width: columns[column].width }}
              >
                <span className="min-h-4 block">{columns[column].title}</span>
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow key={i}>
              {Object.keys(columns).map((column) => (
                <TableCell
                  key={column}
                  className="border-x border-solid border-gray-200 border-collapse text-xs py-0 bg-white/70 h-auto py-1"
                  style={{ width: columns[column].width }}
                >
                  <span className="min-h-4 block">{row[column]}</span>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}

export const TableIdCellPlaceholder = ({
  children,
}: {
  children: ReactNode
}) => {
  return (
    <span className="flex border border-black shadow-none m-0 text-xs h-4 w-4 rounded-full left-0 right-0 m-auto justify-center items-center text-xs p-1.5">
      {children}
    </span>
  )
}
